import { StyleSheet } from 'react-native';

import { Box } from 'components/ui/box';
import type { BoxProps } from 'components/ui/box';

export const ContentContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.contentContainer, style]} />
);

export const NavigationContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.navigationContainer, style]} />
);

export const Stepper = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.stepper, style]} />
);

const styles = StyleSheet.create({
  contentContainer: {
    flex: 1,
  },
  navigationContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
  },
  stepper: {
    marginRight: 24,
  },
});
